import { BookOpen } from "lucide-react";
import { WHATSAPP_CATALOG_URL } from "../data/watches";

export const FloatingWhatsApp = () => {
  return (
    <a
      href={WHATSAPP_CATALOG_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-catalog-button"
      aria-label="Ver catálogo de Romero Watches en WhatsApp"
      className="fixed bottom-6 left-6 z-40 group flex items-center gap-2.5 pl-4 pr-5 py-3.5 rounded-full bg-[var(--brand-whatsapp)] text-black shadow-[0_10px_40px_-10px_rgba(37,211,102,0.55)] hover:bg-[var(--brand-whatsapp-dark)] hover:text-white transition-all duration-300"
    >
      <span className="relative flex items-center justify-center">
        <span className="absolute inline-flex w-full h-full rounded-full bg-white/40 animate-ping" />
        <BookOpen size={18} strokeWidth={2.2} className="relative" />
      </span>
      <span className="font-accent-rw text-[12px] uppercase tracking-[0.24em] font-semibold whitespace-nowrap" translate="no">
        Catálogo
      </span>
    </a>
  );
};

export default FloatingWhatsApp;
